import React, { PureComponent } from 'react';
import './styles.scss';

const CrudSeparatorField = () => {
    return <div className="react-crud-separator-field" />;
};

export default CrudSeparatorField;
